export default __webpack_public_path__ + "static/media/settings.30954086.svg";